export interface EquipmentType {
  typeId: number;
  name?: string;
}

export const DRILL_TYPE_NAMES = ['DRILL', 'FOREUSE', 'PERFORADORA'];
